import useLocation from './useLocation';
export default useLocation;
